<script>
import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
	name: 'revenue-chart',
	extends: Bar,
	mixins: [reactiveProp],
	props: ['chartId', 'options'],
	mounted() {
		if (this.chartId === 'revenue') {
			this.renderChart(this.chartData, this.options);
		}
	},
};
</script>
